import type { Hcp } from '@/core/graphql/generated/types';
import { paths } from '@/core/router/paths';
import { replaceRouteParams } from '@/utils/url/replaceRouteParams';

import { hcpUrl } from './hcpUrl';

export const getHcpProfileLink = (hcp: Hcp): string => {
	const slug = hcpUrl({
		firstName: hcp.firstNameCda_V,
		lastName: hcp.lastNameCda_V,
		id: hcp.vid_V
	});
	return slug ? replaceRouteParams(paths.hcp, { hcpId: slug }) : '';
};
